module.exports = __webpack_public_path__ + "img/paidby.685e40a3.svg";